import React, { useEffect } from 'react';
import './ThankYouEnrollment.css';

const ThankYouEnrollment = () => {
  useEffect(() => {
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute('content', 'noindex, nofollow');

    // Ensure window.gtag exists and fire conversion tracking events
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
    }

    // Event snippet for AQL Trial Submissions conversion page
    window.gtag('event', 'conversion', {
      'send_to': 'AW-11079158555/uh4iCKH17I4YEJuW-qIp'
    });

    // Event snippet for AQL Form Submitted conversion page
    window.gtag('event', 'conversion', {
      'send_to': 'AW-11042074135/E13fCNyg5I4YEJfcopEp'
    });
  }, []);

  return (
    <div className="thank-you-page">
      <div className="thank-you-container">
        <h1 className="thank-you-title">THANK YOU FOR ENROLLING!</h1>
        <p className="thank-you-subtitle">Our Support Team Will Contact You Shortly.</p>

        <div className="thank-you-image-wrapper">
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/qari-vector.png`}
            alt="Our Support Team Will Contact You Shortly"
            className="thank-you-img"
          />
        </div>

        <div className="thank-you-btn-wrapper">
          <a href="/about-us/" className="thank-you-btn">
            LEARN MORE ABOUT US
          </a>
        </div>
      </div>
    </div>
  );
};

export default ThankYouEnrollment;
